import React, { ChangeEvent } from 'react';
import { SelectItem } from 'src/models/common/SelectItem';
import { FormRow, SelectInput, TextInput } from '../reactHookForm';

interface IAddressDataProps {
    namePrefix?: string;
    labelPrefix?: string;
    states: Array<SelectItem>;
    getCityState?: (zipCode: string) => void;
    stateValue?: string | number;
}

const AddressData: React.FC<IAddressDataProps> = (props) => {
    const name = (n: string) => {
        if (props.namePrefix) {
            if (props.namePrefix.endsWith('.')) {
                return `${props.namePrefix}${n}`;
            } else {
                return `${props.namePrefix}${n.charAt(0).toUpperCase() + n.slice(1)}`;
            }
        }
        return n;
    };

    const label = (l: string) => {
        if (props.labelPrefix) {
            return `${props.labelPrefix} ${l}`;
        }
        return l;
    };

    const handleZipcodeChange = (e: ChangeEvent<HTMLInputElement>) => {
        let zipCode: string = e.target.value;

        if (zipCode.length === 5) {
            props?.getCityState(zipCode);
        }
    };

    return (
        <>
            <FormRow layout={[7, 6]}>
                <TextInput label={label('Address Line 1')} name={name('addressLine1')} />
                <TextInput label={label('Address Line 2')} name={name('addressLine2')} />
            </FormRow>
            <FormRow layout={[4, 3, 2, '4_']}>
                <TextInput label={label('Zip Code')} name={name('zipCode')} onChange={handleZipcodeChange} maxLength={5} />
                <TextInput label={label('City')} name={name('city')} />
                <SelectInput label={label('State')} name={name('state.id')} options={props.states} stateValue={props.stateValue} />
            </FormRow>
        </>
    );
};

export default AddressData;



// WEBPACK FOOTER //
// ./src/components/controls/forms/composite/AddressData.tsx